module.exports = __webpack_public_path__ + "static/softball2-196b61a13fbe50a998bf1e4d236a96b6.jpg";